import { DialogContent } from '@mui/material';
import React, { useContext } from 'react';

import { aiAssistantContext } from '../../../../state/AIAssistantContextProvider';
import AIAssistantContentHeadline from './AIAssistantContentHeadline';

type AIAssistantDialogContentWithHeadlineProps = {
	headline: React.ReactNode;
	children: React.ReactNode;
} & React.ComponentProps<typeof DialogContent>;

const AIAssistantDialogContentWithHeadline: React.FC<AIAssistantDialogContentWithHeadlineProps> = ({
	headline,
	children,
	...props
}) => {
	const { dialogContentRef } = useContext(aiAssistantContext);
	return (
		<>
			<AIAssistantContentHeadline>{headline}</AIAssistantContentHeadline>
			<DialogContent ref={dialogContentRef} {...props}>
				{children}
			</DialogContent>
		</>
	);
};

export default AIAssistantDialogContentWithHeadline;
